import React, { useMemo, useState, useCallback} from 'react';
import './TurnaroundTime.css';
import Pagination from '../Pagination/Pagination';

const itemsPerPage = 7;

const TurnaroundTime = React.memo(({ data = [] }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = useMemo(() => Math.ceil(data.length/itemsPerPage), [data]);
  const startIndex = (currentPage - 1) * itemsPerPage;

  const currentData = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    return data.slice(startIndex, startIndex + itemsPerPage);
  }, [data, currentPage]);

const handlePageChange = useCallback(newPage => setCurrentPage(newPage), []);

  return (
    <div className="custom-card p-3 mb-4">
      <div className="turnaround-header">
        <h5 className="turnaround-title">Turnaround Time</h5>
      </div>
      
      <div className="turnaround-content">
        <div className="turnaround-table-header">
          <span className="header-member">Member</span>
          <span className="header-tasks">Tasks</span>
          <span className="header-time">Turnaround Time</span>
        </div>
        
        <div className="turnaround-list">
          {data.length > 0 ? (
            currentData.map((item, index) => (
              <div key={startIndex + index} className="turnaround-row">
                <div className="member-info">
                  <div className="member-avatar">
                    {item.member.charAt(0).toUpperCase()}
                  </div>
                  <span className="member-name">{item.member}</span>
                </div>
                <div className="tasks-count">{item.tasks}</div>
                <div className="turnaround-time">{item.time}</div>
              </div>
            ))
          ) : (
            <div className="no-data">No turnaround data available</div>
          )}
        </div>
        {totalPages > 1 && (
          <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
          />
        )}
      </div>
    </div>
  );
});

export default TurnaroundTime;
